import { Room } from '../community';
import { HelperCard } from './model/HelperCard';
import { IcareMessage } from './model/IcareMessage';
import { MessageType } from './model/MessageType';

export const createGUID = () => {
  let dt = new Date().getTime();
  const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
    /[xy]/g,
    function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};

export const helpCardIcon: HelperCard[] = [
  {
    message: 'How do I navigate the site?',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/148.svg',
  },
  {
    message: 'Information about a condition',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/159.svg',
  },
  {
    message: 'Analyze my health journey',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/153.svg',
  },
];
export const navigateToSectionCards: HelperCard[] = [
  {
    message: 'Community',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/148.svg',
  },
  {
    message: 'Health Journey',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/159.svg',
  },
  {
    message: 'Stories',
    iconLink: 'https://carecircle.azureedge.net/images-avatars/153.svg',
  },
];

export const messagesMock: IcareMessage[] = [
  {
    id: createGUID(),
    messageText:
      'Hi Emily, I am the i.care and I am here to help you with any questions you might have. All the conversations are strictly confidential and no one has access to the data provided. I will be adding more functionalities and diagnostics over time and share insights.',
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.text,
    dateCreated: new Date().toUTCString(),
  },
  {
    id: createGUID(),
    messageText: 'Could I help you with any of the following today?',
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.text,
    dateCreated: new Date().toUTCString(),
  },
  {
    id: createGUID(),
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.helpCard,
    messageOptions: helpCardIcon,
    clicked: false,
    dateCreated: new Date().toUTCString(),
  },
];

export const navigateToSection: IcareMessage[] = [
  {
    id: createGUID(),
    messageText: 'In which section of the site are you interested?',
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.text,
    dateCreated: new Date().toUTCString(),
  },
  {
    id: createGUID(),
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.helpCard,
    messageOptions: navigateToSectionCards,
    clicked: false,
    dateCreated: new Date().toUTCString(),
  },
];

export const conditionInfoCards: HelperCard[] = [
  {
    message: 'Headache',
  },
  {
    message: 'Fever',
  },
];
export const conditionInfo: IcareMessage[] = [
  {
    id: createGUID(),
    messageText:
      'I see that you have some conditions in your health journey, would you like information about these? If not, please type the condition in the text field below. ',
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.text,
    dateCreated: new Date().toUTCString(),
  },
  {
    id: createGUID(),
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.helpCard,
    messageOptions: conditionInfoCards,
    clicked: false,
    dateCreated: new Date().toUTCString(),
  },
];

export const roomItem: Room = {
  id: 'b3a76475-f815-4d5f-87d7-653712a512ee',
  picurl:
    'https://carecircle.blob.core.windows.net/images-rooms/b3a76475-f815-4d5f-87d7-653712a512ee.png',
  title: 'New members',
  content: 'New Members try here',
  postCount: 25,
  memberCount: 16,
  isMember: true,
  dateCreated: '2021-07-08T00:00:00',
  dateUpdated: '2021-07-08T00:00:00',
  isPrivate: false,
  consent: null,
};

export const feverInfo: IcareMessage[] = [
  {
    id: createGUID(),
    messageText: 'Here is what I have found for you:',
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.text,
    dateCreated: new Date().toUTCString(),
  },
  {
    id: createGUID(),
    picUrl: 'https://carecircle.azureedge.net/images-avatars/1.svg',
    senderId: 'robot',
    messageType: MessageType.helpRoom,
    messageOptions: roomItem,
    clicked: false,
    dateCreated: new Date().toUTCString(),
  },
];
